<template>
  <v-container fluid style="height: 100%">
    <v-row no-gutters>
      <v-col>
        <v-btn icon v-if="infoMaximum" @click="onInfoMaximum" class="float-right"
          ><v-icon>mdi-window-minimize</v-icon></v-btn
        >
        <v-btn icon v-if="!infoMaximum" @click="onInfoMaximum" class="float-right"
          ><v-icon>mdi-window-maximize</v-icon></v-btn
        >
        <v-tabs v-model="tab" centered grow class="mt-2 mb-2" hide-slider>
          <v-tab>詳細</v-tab>
          <v-tab>変更履歴</v-tab>
        </v-tabs>
        <v-divider></v-divider>
        <v-tabs-items v-model="tab" id="tab-items">
          <v-tab-item>
            <proposition-details
              :style="detaleStyle"
              :details="detailDetails.length > 0 ? detailDetails : details"
            ></proposition-details>
          </v-tab-item>
          <v-tab-item>
            <proposition-history :propositionId="propositionId" v-if="!propositionDetailId"></proposition-history>
            <proposition-detail-history
              :propositionDetailId="propositionDetailId"
              v-if="propositionDetailId"
            ></proposition-detail-history>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import PropositionDetails from "./PropositionDetails.vue";
import PropositionHistory from "./PropositionHistory.vue";
import PropositionDetailHistory from "./PropositionDetailHistory.vue";

export default {
  name: "PropositionInfos",
  props: ["details", "detailDetails", "propositionId", "propositionDetailId"],
  data: () => ({
    tab: null,
    items: ["1", "2"],
    infoMaximum: false,
    detaleStyle: {
      height: window.innerHeight - 260 + "px",
      overflow: "scroll",
    },
  }),
  components: {
    PropositionDetails,
    PropositionHistory,
    PropositionDetailHistory,
  },
  methods: {
    onInfoMaximum: function () {
      this.infoMaximum = !this.infoMaximum;
      this.$emit("infoMaximum-event");
    },
    handleResize: function () {
      this.detaleStyle.height = window.innerHeight - 260 + "px";
    },
  },
  mounted: function () {
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy: function () {
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>
